import {useEffect} from 'react';
import {DEFAULT_ANIMATION_DURATION} from '../../common/scss/util/variable';
import {IMessageProps} from '../../home/common/type';

interface IUseDelayClosePopup extends IMessageProps {
  isShowPopup: boolean;
}

export default function useDelayClosePopup({
  isShowPopup,
  onFinish,
}: IUseDelayClosePopup) {
  useEffect(() => {
    const timerId = setTimeout(() => {
      !isShowPopup && onFinish?.();
    }, DEFAULT_ANIMATION_DURATION);
    return () => clearTimeout(timerId);
  }, [isShowPopup, onFinish]);
}
